import { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { storePartnerHash } from '@/lib/deep-link';
import { httpClient } from '@/api/http-client';

export function PartnerRedirectPage() {
  const { hash } = useParams<{ hash: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const processReferral = async () => {
      if (hash) {
        // 1. Persistir o hash de indicação no storage do cliente
        storePartnerHash(hash);

        // 2. Registrar o clique no backend para gravar os cookies de 30 dias
        try {
          await httpClient.post('/tracking/click', {
            slug: hash,
            source: 'LINK',
            landingUrl: window.location.href,
            referrerUrl: document.referrer || undefined,
          });
        } catch (err) {
          console.debug('Tracking click recorded locally:', err);
        }
      }

      // 3. Determina destino inteligente caso o link contenha serviço ou modalidade
      const service = (searchParams.get('service') || '').toLowerCase();
      const modality = (searchParams.get('modality') || '').toUpperCase();
      const to = searchParams.get('to');

      let targetPath = '/';

      if (to && to.startsWith('/')) {
        targetPath = to;
      } else if (service === 'expressa' || service === 'plantao' || service === 'pronto-atendimento') {
        targetPath = '/expressa';
      } else if (service === 'telemedicina' || modality === 'TELEMEDICINA') {
        targetPath = '/medicos?modality=TELEMEDICINA';
      } else if (service === 'presencial' || modality === 'PRESENCIAL') {
        targetPath = '/medicos?modality=PRESENCIAL';
      } else if (service === 'domiciliar' || modality === 'DOMICILIAR') {
        targetPath = '/medicos?modality=DOMICILIAR';
      }

      navigate(targetPath, { replace: true });
    };

    processReferral();
  }, [hash, searchParams, navigate]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <div className="text-center space-y-4">
        <div className="w-12 h-12 border-3 border-primary/20 border-t-primary rounded-full animate-spin mx-auto" />
        <p className="text-sm font-medium text-muted-foreground">
          Conectando indicação de parceiro...
        </p>
      </div>
    </div>
  );
}
